import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import LoginPage from './LoginPage';

const AuthGuard = ({ children }) => {
  const { isAuthenticated, isLoading, login, isDevMode } = useAuth();

  // Mostra um loading enquanto verifica a autenticação
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#252722' }}>
        <div className="text-center">
          <div className="inline-block w-12 h-12 border-4 border-green-200 rounded-full animate-spin border-t-green-600 mb-4"></div>
          <p className="text-white text-lg">Verificando autenticação...</p>
          {isDevMode && (
            <p className="text-gray-400 text-sm mt-2">
              🔓 Modo de desenvolvimento ativo
            </p>
          )}
        </div>
      </div>
    );
  }

  // Se não estiver autenticado, mostra a página de login
  if (!isAuthenticated) {
    return <LoginPage onLoginSuccess={login} />;
  }

  // Se estiver autenticado, renderiza o conteúdo protegido
  return <>{children}</>;
};

export default AuthGuard;
